"use strict";
import request from "@/utils/request";
const config = require("@/../config/config.json");
import logger from "@/utils/logger";

let baseURL = `${config.apiUrl}staff`;

export async function svc_editBrand(staffID, brands) {
	return request(`${baseURL}/${staffID}/brands`, {
		method: "POST",
		data: { brands },
	});
}
export async function svc_editOutlets(staffID, outlets) {
	return request(`${baseURL}/${staffID}/outlets`, {
		method: "POST",
		data: { outlets },
	});
}
export async function svc_editPolicies(staffID, policies) {
	return request(`${baseURL}/${staffID}/policies`, {
		method: "POST",
		data: { policies },
	});
}

export async function svc_changePassword(staffID, password) {
	return request(`${baseURL}/${staffID}/change_password`, {
		method: "POST",
		data: { password },
	});
}
